var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkLOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 2.7998,
    y: 1.79688,
    width: 26.4004,
    height: 28.4062
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_26_1402_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 7H9C8.44772 7 8 7.44772 8 8V25L16 19.375L24 25V8C24 7.44772 23.5523 7 23 7Z",
    fill: "#191F28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 6.40039C23.8837 6.40039 24.5996 7.11634 24.5996 8V25C24.5996 25.224 24.4751 25.429 24.2764 25.5322C24.0778 25.6353 23.8384 25.6197 23.6553 25.4912L16 20.1084L8.34473 25.4912C8.16159 25.6197 7.92222 25.6353 7.72363 25.5322C7.52488 25.429 7.40039 25.224 7.40039 25V8C7.40039 7.11634 8.11634 6.40039 9 6.40039H23Z",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_26_1402_clip_path",
    transform: "translate(-2.7998 -1.79688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 7H9C8.44772 7 8 7.44772 8 8V25L16 19.375L24 25V8C24 7.44772 23.5523 7 23 7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkLOn);
export default __webpack_public_path__ + "static/media/bookmark_L_ON.56c8b5f7d786278acd5d4a44b7fba3eb.svg";
export { ForwardRef as ReactComponent };